import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import _ from 'lodash';
import { Calculator } from '@deerplusofficial/pos-components';

export default config => Component => {
  return class extends React.Component {
    static displayName = wrapDisplayName(Component, 'WithCalculator');

    static propTypes = {
      showCalculator: PropTypes.bool,
      onChange: PropTypes.func,
      displayValue: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      advanced: PropTypes.bool,
      large: PropTypes.bool,
    };

    static defaultProps = {
      showCalculator: false,
      onChange: _.identity,
      displayValue: undefined,
      value: undefined,
      advanced: false,
      large: false,
    };

    ref = element => (this.calculator = element);

    onKeyDown = e => this.calculator.onButtonPress(e);

    renderCalculator = () => {
      const props = _.pick(this.props, [
        'value',
        'onChange',
        'advanced',
        'large',
      ]);

      return (
        <Calculator
          ref={this.ref}
          mode={this.props.calculatorMode}
          {...props}
        />
      );
    };

    render() {
      const {
        onChange,
        showCalculator,
        value,
        displayValue,
        ...props
      } = this.props;

      return (
        <React.Fragment>
          <Component
            onKeyDown={this.onKeyDown}
            onChange={onChange}
            value={displayValue || value}
            {...props}
          />
          {showCalculator && this.renderCalculator()}
        </React.Fragment>
      );
    }
  };
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-hoc/src/withCalculator.js